import React from 'react';
import { Euro, Calculator, FileText } from 'lucide-react';

const services = [
  {
    icon: Euro,
    title: 'Estimation en ligne',
    description: 'Estimation gratuite et instantanée basée sur nos algorithmes avancés.',
    features: [
      'Résultat en 5 minutes',
      'Données du marché en temps réel',
      'Rapport PDF détaillé'
    ]
  },
  {
    icon: Calculator,
    title: 'Visite d\'expert',
    description: 'Estimation approfondie avec visite sur place par un expert certifié.',
    features: [
      'Analyse détaillée sur place',
      'Conseils personnalisés',
      'Rapport d\'expertise complet'
    ]
  },
  {
    icon: FileText,
    title: 'Veille de marché',
    description: 'Suivez l\'évolution des prix dans votre quartier.',
    features: [
      'Alertes prix personnalisées',
      'Analyse des tendances',
      'Rapports mensuels'
    ]
  }
];

export default function Services() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Nos services d'estimation
          </h2>
          <p className="mt-4 text-xl text-gray-700">
            Des solutions adaptées à tous vos besoins immobiliers
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white/80 backdrop-blur-xl p-8 shadow-[0_8px_32px_rgba(42,67,101,0.15)]
                transform hover:scale-[1.02] transition-all duration-300
                relative overflow-hidden rounded-xl"
            >
              <div className="relative z-10">
                <div className="h-12 w-12 bg-gradient-to-br from-[#2A4365] via-[#4A5568] to-[#C4A052] rounded-xl flex items-center justify-center mb-6">
                  <service.icon className="h-6 w-6 text-white" strokeWidth={2.5} />
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>

                <p className="text-gray-700 mb-6">
                  {service.description}
                </p>

                <ul className="space-y-3">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-700">
                      <svg
                        className="h-5 w-5 text-[#2A4365] mr-3 flex-shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2.5}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}